// extracted by mini-css-extract-plugin
export default {"load-more":"load-more-01ff","top-left-tag":"top-left-tag-4e94","progress":"progress-33de","rejected":"rejected-2ae9","navy":"navy-e036","image-text":"image-text-c5e2"};